import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { AppDispatch, AppState } from "..";
import { extraEntityReducersFunction, loadStatus } from "./entitiesType";
import { FabricStore } from "../../powershadesApiTypes";
import store from "..";
import apiCalls from "../../PowerShadesAPIFunctions";
import { createSelector } from "reselect";


export const loadFabrics = createAsyncThunk<FabricStore[], null, {
    rejectValue: boolean;
}>(
	'entities/GetFabrics',
	async (_inputs, { rejectWithValue }) => {
		let fabrics: FabricStore[] = [];

		try {
			const resp = await apiCalls.getFabricList();

			fabrics = resp.data.fabrics.map(fabVM => ({
				name: fabVM.name,
				imageUrl: "",
				imageLoaded: loadStatus.notLoaded,
				isNextLoad: false,
				fabric_color: "",
				fabric_pattern: "",
				is_indoor: fabVM.is_indoor,
				is_outdoor: fabVM.is_outdoor,
				is_psoutdoor: fabVM.is_psoutdoor,
				is_seamable: fabVM.is_seamable,
				is_railroadable: fabVM.is_railroadable
			}));	
		} catch (err: any) {
			const error: AxiosError = err;

			console.error(error);

			return rejectWithValue(false);
		}

		return fabrics.map((f) => ({ ...f, imageLoaded: loadStatus.notLoaded }));
	}
);

// export const loadFabricImage = (fabricName : string) => createAsyncThunk<string, string, {
//     rejectValue: boolean,
// }>(
//     `entities/LoadFabricImage/${fabricName}`,
//     async (fabricName, { rejectWithValue }) => {

//         let fabricImageUrl : string = "";

//         try {

//             let resp = await api.getFabricImage(fabricName);

//             let dataStr = resp.data;

//             var myblob = new Blob([dataStr], {
//                 type: 'text/plain'
//             });

//             let url = window.URL.createObjectURL(myblob)

//             fabricImageUrl = url;

//         } catch (err: any) {
//             let error: AxiosError = err;

//             console.error(error);

//             return rejectWithValue(false)
//         }

//         return fabricImageUrl;
//     }
// )(fabricName)

export const EnsureFabrics = (storeState: AppState, dispatch: AppDispatch) => {
	if (storeState.entity.fabrics.loadStatus != loadStatus.fullyLoaded) {
		dispatch(loadFabrics(null));
	}
};

export const SelectFabricsUnsorted =  (storeState: AppState) => {
	if (storeState.entity.fabrics.loadStatus != loadStatus.metaLoaded && storeState.entity.fabrics.loadStatus != loadStatus.loading) {
		store.dispatch(loadFabrics(null));
	}
	return storeState.entity.fabrics.list
};
export const SelectFabrics =  createSelector(SelectFabricsUnsorted, (fabrics) => fabrics.map(f => f).sort((f1,f2) => f1.name.localeCompare(f2.name)));

export const SelectPSOutdoorFabrics = createSelector(SelectFabrics, (fabrics) => fabrics.filter((f) => f.is_psoutdoor));

export const SelectOutdoorFabrics = createSelector(SelectFabrics, (fabrics) => fabrics.filter((f) => f.is_outdoor));

export const SelectIndoorFabrics = createSelector(SelectFabrics, (fabrics) => fabrics.filter((f) => f.is_indoor));

export const SelectFabricImageUrl = (fabricName: string) => (store: AppState) => store.entity.fabrics.list.find((f) => f.name == fabricName)?.imageUrl ?? null;



export const fabricBuilder: extraEntityReducersFunction = (builder) => {
	builder.addCase(loadFabrics.pending, (state) => {
		return { ...state, fabrics: { list: [], loadStatus: loadStatus.loading } };
	});

	builder.addCase(loadFabrics.fulfilled, (state, action) => {
		const fabrics = action.payload;	

		return { ...state, fabrics: { list: fabrics, loadStatus: loadStatus.metaLoaded } };
	});

	builder.addMatcher((action) => {
		const type = action.type as string;
		return type.includes("entities/LoadFabricImage/");
	}, (state, action: PayloadAction<string, string, {
        arg: null;
        requestId: string;
        requestStatus: "fulfilled";
    }, never>) => {
		const imageUrl = action.payload;

		const items = action.type.split("/");
		const fabricName = items[2];

		const fabric = state.fabrics.list.find((f) => f.name == fabricName);

		if (fabric == null) {
			return state;
		}
		const newFabric: FabricStore = {
			...fabric,
			imageUrl,
			imageLoaded: loadStatus.fullyLoaded
		};

		state.fabrics.list = state.fabrics.list.map((l) => (l.name == fabricName ? newFabric : l));

		return state;
	});
};
